"use client";
import { forwardRef, useCallback } from "react";
import SearchInput from "../../common/components/SearchInput";
import { useTranslations } from "next-intl";

const SearchHandlerInput = forwardRef<
  HTMLInputElement,
  {
    onSearch: (val) => any;
    searchTerm: string;
    setSearchTerm: (val) => any;
    onChange?: (val) => any;
    onClick?: (val) => any;
  }
>(({ onSearch, searchTerm, setSearchTerm, onChange, onClick = null }, ref) => {
  const t = useTranslations();
  const handleEnter = useCallback(
    (event) => {
      if (event.key === "Enter") {
        onSearch(searchTerm);
      }
    },
    [onSearch, searchTerm],
  );
  return (
    <SearchInput
      ref={ref}
      onReset={() => setSearchTerm("")}
      onKeyDown={handleEnter}
      onClick={onClick}
      onFocus={() => {}}
      onSearch={onSearch}
      className="button--dimmed form-field search-field"
      value={searchTerm ?? ""}
      defaultValue={searchTerm}
      placeholder={t("search")}
      id="navigation-search-input"
      onChange={(e) => {
        setSearchTerm(e.target.value);
        onChange?.(e);
      }}
    />
  );
});

SearchHandlerInput.displayName = "SearchHandlerInput";
export default SearchHandlerInput;
